import { ITennisTourRanking } from "@sky-it-livedata/livedata-sports-design-system";
import { RankingSubscriptionData } from "./types";
import { loggerFactory } from "@sky-it-livedata-libraries/livedata-commons";
import errors from "../../utils/errors";

const logger = loggerFactory();

const isValidObject = (obj: RankingSubscriptionData) =>
  Boolean(obj?.data?.onUpdateRankingWidgetByCircuitType);

export const transformSubscription = (obj: RankingSubscriptionData): ITennisTourRanking => {
  if (isValidObject(obj)) {
    try {
      const { rankings } = obj?.data?.onUpdateRankingWidgetByCircuitType!;

      return {
        ranking: rankings?.map((item) => {
          return {
            position: item?.rank,
            flagUrl: item?.nationality,
            name: item?.playerName,
            score: Number(item?.points),
            trend: Number(item?.trend),
            id: item?.rank?.toString(),
      }}),
      } as ITennisTourRanking;
    } catch (error) {
      logger.error(
        "ERROR 3003: transform() error in Ranking transformer",
        obj
      );
      throw errors.fromCode(3003);
    }
  } else {
    logger.error("ERROR 3002", obj);
    throw errors.fromCode(3002);
  }
};

